import axios from 'axios';
import get from 'lodash/get';
import AppResourceCollection
    from '@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection';
import AddressAppResource
    from '@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource';

export const addressMatch = async (params) => {
    const requestParams = {
        term: null,
        limit: 10,
        ...params,
    };

    const response = await axios.get(
        `${window.env.HJ_HOST}/ws/addresses/match`,
        {
            headers: {
                Authorization: `${window.env.HJ_PUBLIC_KEY}`,
            },
            params: requestParams,
        });
    return get(response, 'data.result.matches', []);
};


export const addressSearch = async (params) => {
    const requestParams = {
        term: null,
        limit: 1,
        ...params,
    };

    const response = await axios.get(
        `${window.env.HJ_HOST}/ws/addresses/search`,
        {
            headers: {
                Authorization: `${window.env.HJ_PUBLIC_KEY}`,
            },
            params: requestParams,
        });
    return get(response, 'data.result.addresses', []);
};

export const addressStandardize = async (params) => {
    const response = await axios.get(
        `${window.env.HJ_HOST}/ws/addresses/standardize`,
        {
            headers: {
                Authorization: `${window.env.HJ_PUBLIC_KEY}`,
            },
            params: params,
        });
    return get(response, 'data.result', {address: '', coordinates: {latitude: null, longitude: null}});
};

export const areasZipcodes = async (params) => {
    const response = await axios.get(
        `${window.env.HJ_HOST}/ws/areas/zipcodes/get`,
        {
            headers: {
                Authorization: `${window.env.HJ_PUBLIC_KEY}`,
            },
            params: params,
        });
    return get(response, 'data.result', {address: '', coordinates: {latitude: null, longitude: null}});
};

export const homeJunctionToCollection = (addresses) => {
    const collection = new AppResourceCollection('address');

    for (const address of addresses) {
        collection.addResource(new AddressAppResource({
            attributes: {
                fullAddress: address.label,
                city: address.city,
                country: 'USA',
                state: address.state,
                postalCode: address.zip,
                street: address.components.streetName,
                streetNumber: address.components.primaryNumber,
                deliveryLine: address.deliveryLine,
                zip: address.zip,
                postDirection: address.components?.postdirectional,
                preDirection: address.components?.predirectional,
                suffix: address.components?.suffix,
            },
        }));
    }

    return collection;
};

export const addressGeocode = async (params) => {
    const response = await axios.get(
        `${window.env.HJ_HOST}/ws/addresses/geocode`,
        {
            headers: {
                Authorization: `${window.env.HJ_PUBLIC_KEY}`,
            },
            params: params,
        });
    return get(response, 'data.result', {address: '', coordinates: {latitude: null, longitude: null}});
};
